import { render, staticRenderFns } from "./SuperSyndicateStats.vue?vue&type=template&id=52853a72&scoped=true&"
import script from "./SuperSyndicateStats.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicateStats.vue?vue&type=script&lang=js&"
import style0 from "./Styles/SuperSyndicate.css?vue&type=style&index=0&id=52853a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52853a72",
  null
  
)

export default component.exports